import { css } from 'emotion'

export const TaskSummarySpanStyles = css``
